import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickMutation } from "../types";
import { getApi } from "../apiPath";
import { axiosClient, queryClient } from "../clients";

import type { IUsers } from "./routeType";
import { useGetAllUser } from "./getAll";
import { useGetUser } from "./get";
import { useGetProfile } from "./me";

const { getPath } = getApi("users.put");

type IExtractedRouteType = IUsers["userSingleUpdate"];

export type IPutUsers = IPickMutation<IExtractedRouteType>;

const putUser: MutationFunction<
  IPutUsers["response"],
  IPutUsers["variables"]
> = ({ userId, ...data }) => {
  return axiosClient.put(getPath({ userId }), data);
};

export const usePutUser = createMutation({
  mutationFn: putUser,
  onSuccess: (_, { userId }) => {
    queryClient.invalidateQueries({ queryKey: useGetAllUser.getKey() });
    queryClient.invalidateQueries({
      queryKey: useGetUser.getKey({ userId }),
    });
    queryClient.invalidateQueries({
      queryKey: useGetProfile.getKey(),
    });
  },
});
